import { useCallback } from "react";
import { hasPermission, getRolePermissions, getRoleInfo, getRoleNavigation, getRoleLandingPath } from "@/mocks/rbac";
import type { UserProfile } from "@/components/feature/Sidebar";

export function useRole(user: UserProfile | null) {
  const roleId = user?.rol || "";

  const can = useCallback(
    (permissionCode: string): boolean => {
      if (!user) return false;
      return hasPermission(roleId, permissionCode);
    },
    [roleId, user]
  );

  const canAny = useCallback(
    (permissionCodes: string[]): boolean => {
      return permissionCodes.some((code) => can(code));
    },
    [can]
  );

  const canAll = useCallback(
    (permissionCodes: string[]): boolean => {
      return permissionCodes.every((code) => can(code));
    },
    [can]
  );

  const permissions = user ? getRolePermissions(roleId) : [];
  const roleInfo = getRoleInfo(roleId);
  const navigation = getRoleNavigation(roleId);
  const landingPath = getRoleLandingPath(roleId);

  return {
    roleId,
    roleInfo,
    can,
    canAny,
    canAll,
    permissions,
    navigation,
    landingPath,
  };
}

export function getRoleLabel(roleId: string): string {
  const labels: Record<string, string> = {
    director: "Director",
    convivencia: "Encargado de Convivencia",
    orientador: "Orientador/a",
    psicologo: "Psicólogo/a",
    inspector: "Inspector General",
    profesor_jefe: "Profesor Jefe",
    docente: "Docente",
    admin: "Administrador",
    sostenedor: "Sostenedor",
    admin_saas: "Admin SaaS",
    superadmin: "Super Admin (SaaS)",
  };
  return labels[roleId] || roleId;
}